import { Component } from 'react';
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from 'react-router-dom';
import AdminAdvogadoForm from '../pages/Admin/Advogado/Form';
import AdminAdvogadoList from '../pages/Admin/Advogado/List';
import AdminAlterarPlano from '../pages/Admin/AlterarPlano';
import AdminAlterarPlanoCart from '../pages/Admin/AlterarPlanoCart';
import AdminAtualizacoes from '../pages/Admin/Atualizacoes/List';
import AdminBanners from '../pages/Admin/Banners/List';
import AdminChatForm from '../pages/Admin/Chat/Form';
import AdminChatList from '../pages/Admin/Chat/List';
import AdminClientCommentForm from '../pages/Admin/ClientComment/Form';
import AdminClientCommentList from '../pages/Admin/ClientComment/List';
import AdminClientDocumentForm from '../pages/Admin/ClientDocument/Form';
import AdminClientDocumentList from '../pages/Admin/ClientDocument/List';
import AdminClienteForm from '../pages/Admin/Cliente/Form';
import AdminClienteList from '../pages/Admin/Cliente/List';
import AdminComunicacao from '../pages/Admin/Comunicacao/Lista';
import AdminDashboard from '../pages/Admin/Dashboard';
import Dash from '../pages/Admin/Dashs';
import AdminEquipeForm from '../pages/Admin/Equipe/Form';
import AdminEquipeList from '../pages/Admin/Equipe/List';
import AdminEscritorioEquipeForm from '../pages/Admin/Escritorio/Equipe/Form';
import AdminEscritorioEquipeList from '../pages/Admin/Escritorio/Equipe/List';
import AdminEscritorioForm from '../pages/Admin/Escritorio/Form';
import AdminEscritorioList from '../pages/Admin/Escritorio/List';
import AdminEscritorioPlano from '../pages/Admin/Escritorio/Plano';
import AdminEscritorioTipoUsuarioForm from '../pages/Admin/Escritorio/TipoUsuario/Form';
import AdminEscritorioTipoUsuarioList from '../pages/Admin/Escritorio/TipoUsuario/List';
import AdminEspecialidadeForm from '../pages/Admin/Especialidade/Form';
import AdminEspecialidadeList from '../pages/Admin/Especialidade/List';
import AdminGrupoPermissaoForm from '../pages/Admin/GrupoPermissao/Form';
import AdminGrupoPermissaoList from '../pages/Admin/GrupoPermissao/List';
import AdminMetodoPagamentoForm from '../pages/Admin/MetodoPagamento/Form';
import AdminMetodoPagamentoList from '../pages/Admin/MetodoPagamento/List';
import AdminMeuPerfil from '../pages/Admin/MeuPerfil';
import AdminMinhaConta from '../pages/Admin/MinhaConta';
import AdminMyProcessList from '../pages/Admin/MyProcess/List';
import AdminMyProcessPrestacaoContas from '../pages/Admin/MyProcess/PrestacaoContas';
import AdminMyProcessCommentList from '../pages/Admin/MyProcessComment/List';
import AdminPageAceites from '../pages/Admin/Page/Aceites';
import AdminPageForm from '../pages/Admin/Page/Form';
import AdminPageList from '../pages/Admin/Page/List';
import AdminPagePage from '../pages/Admin/Page/Page';
import AdminPageView from '../pages/Admin/Page/View';
import AdminParteContrariaForm from '../pages/Admin/ParteContraria/Form';
import AdminParteContrariaList from '../pages/Admin/ParteContraria/List';
import AdminPerguntaForm from '../pages/Admin/Pergunta/Form';
import AdminPerguntaList from '../pages/Admin/Pergunta/List';
import AdminPermissaoForm from '../pages/Admin/Permissao/Form';
import AdminPermissaoList from '../pages/Admin/Permissao/List';
import AdminPlanoConfig from '../pages/Admin/Plano/Config';
import AdminPlanoConfigForm from '../pages/Admin/Plano/Config/Form';
import AdminPlanoConfigList from '../pages/Admin/Plano/Config/List';
import AdminPlanoForm from '../pages/Admin/Plano/Form';
import AdminPlanoList from '../pages/Admin/Plano/List';
import AdminProcessForm from '../pages/Admin/Process/Form';
import AdminProcessList from '../pages/Admin/Process/List';
import AdminProcessPrestacaoContas from '../pages/Admin/Process/PrestacaoContas';
import AdminProcessCommentForm from '../pages/Admin/ProcessComment/Form';
import AdminProcessCommentList from '../pages/Admin/ProcessComment/List';
import AdminProcessDocumentForm from '../pages/Admin/ProcessDocument/Form';
import AdminProcessDocumentList from '../pages/Admin/ProcessDocument/List';
import AdminProcessFinancialForm from '../pages/Admin/ProcessFinancial/Form';
import AdminProcessFinancialList from '../pages/Admin/ProcessFinancial/List';
import AdminProcessoChanceGanharForm from '../pages/Admin/ProcessoChanceGanhar/Form';
import AdminProcessoChanceGanharList from '../pages/Admin/ProcessoChanceGanhar/List';
import AdminProcessoInstanciaForm from '../pages/Admin/ProcessoInstancia/Form';
import AdminProcessoInstanciaList from '../pages/Admin/ProcessoInstancia/List';
import AdminProcessoSituacaoForm from '../pages/Admin/ProcessoSituacao/Form';
import AdminProcessoSituacaoList from '../pages/Admin/ProcessoSituacao/List';
import AdminProcessoStatusForm from '../pages/Admin/ProcessoStatus/Form';
import AdminProcessoStatusList from '../pages/Admin/ProcessoStatus/List';
import AdminProcessoTipoAcaoForm from '../pages/Admin/ProcessoTipoAcao/Form';
import AdminProcessoTipoAcaoList from '../pages/Admin/ProcessoTipoAcao/List';
import AdminProcessoTribunalForm from '../pages/Admin/ProcessoTribunal/Form';
import AdminProcessoTribunalList from '../pages/Admin/ProcessoTribunal/List';
import AdminRelatoriosList from '../pages/Admin/Relatorios/List';
import AdminTagForm from '../pages/Admin/Tags/Form';
import AdminTagList from '../pages/Admin/Tags/List';
import AdminTaskForm from '../pages/Admin/Tarefas/Form';
import AdminTarefaList from '../pages/Admin/Tarefas/List';
import AdminTaskCommentForm from '../pages/Admin/TaskComment/Form';
import AdminTaskCommentList from '../pages/Admin/TaskComment/List';
import AdminTaskDocumentForm from '../pages/Admin/TaskDocument/Form';
import AdminTaskDocummentList from '../pages/Admin/TaskDocument/List';
import AdminTipoDeUsuarioForm from '../pages/Admin/TipoDeUsuario/Form';
import AdminTipoDeUsuarioList from '../pages/Admin/TipoDeUsuario/List';
import AdminTreinamentoEmbed from '../pages/Admin/Treinamento/Embed';
import AdminTreinamentoForm from '../pages/Admin/Treinamento/Form';
import AdminTreinamentoList from '../pages/Admin/Treinamento/List';
import AdminUsuarioForm from '../pages/Admin/Usuario/Form';
import AdminUsuarioList from '../pages/Admin/Usuario/List';
import AdminWiki from '../pages/Admin/Wiki/List';
import AuthForgot from '../pages/Auth/Forgot';
import AuthLogin from '../pages/Auth/Login';
import ControllerPage404 from '../pages/Controller/Page404';
import WebAbout from '../pages/Web/About';
import WebAdvogado from '../pages/Web/Advogados';
import WebRegister from '../pages/Web/Cadastrese';
import WebContact from '../pages/Web/Contact';
import WebFAQ from '../pages/Web/FAQ';
import WebHome from '../pages/Web/Home';
import WebMain from '../pages/Web/Main';
import WebPerfil from '../pages/Web/Perfil';
import WebPerfilCliente from '../pages/Web/PerfilCliente';
import WebPerfilContato from '../pages/Web/PerfilContato';
import WebPerfilEquipe from '../pages/Web/PerfilEquipe';
import WebPerfilGaleria from '../pages/Web/PerfilGaleria';
import WebPerfilSobre from '../pages/Web/PerfilSobre';
import WebPlans from '../pages/Web/Plans';
import WebPolicy from '../pages/Web/Policy';
import WebTerm from '../pages/Web/Term';

class AppStack extends Component {
  render = () => {
    return (
      <BrowserRouter>
        <Routes>
          <Route element={<WebMain />} path="">
            <Route element={<WebHome />} path="" />
            <Route element={<WebAbout />} path="quemsomos" />
            <Route element={<WebPlans />} path="planos" />
            <Route element={<WebFAQ />} path="faq" />
            <Route element={<WebAdvogado />} path="advogados" />
            <Route element={<WebContact />} path="contato" />
            <Route element={<WebPolicy />} path="politica" />
            <Route element={<WebTerm />} path="termos" />
            <Route element={<WebRegister />} path="cadastrese" />
            <Route element={<ControllerPage404 />} path="*" />
          </Route>
          <Route element={<WebPerfil />} path="advogados/:id">
            <Route element={<Navigate to="sobre" />} path="" />
            <Route element={<WebPerfilSobre />} path="sobre" />
            <Route element={<WebPerfilEquipe />} path="nossaequipe" />
            <Route element={<WebPerfilContato />} path="contatos" />
            <Route element={<WebPerfilCliente />} path="clientes" />
            <Route element={<WebPerfilGaleria />} path="galeria" />
          </Route>
          <Route element={<AuthLogin />} path="login" />
          <Route element={<AuthForgot />} path="esqueceuasenha" />
          <Route element={<AdminDashboard />} path="painel">
            <Route element={<Dash />} path="" />
            <Route
              element={<AdminBanners path="banners" per="alb" type="edit" />}
              path="banners"
            />
            <Route
              element={<AdminMyProcessList type="list" />}
              path="meusprocessos"
            />
            <Route
              element={<AdminMyProcessCommentList type="list" />}
              path="meusprocessos/:id/comentarios"
            />
            <Route
              element={<AdminMyProcessPrestacaoContas type="list" />}
              path="meusprocessos/:id/prestacaodecontas"
            />
            <Route element={<AdminMeuPerfil />} path="meusite" />
            <Route element={<AdminMinhaConta />} path="minhaconta" />
            <Route
              element={<AdminComunicacao per="cmn" type="list" />}
              path="comunicacao"
            />
            <Route
              element={<AdminAlterarPlano />}
              path="minhaconta/alterarplano"
            />
            <Route
              element={<AdminAlterarPlanoCart />}
              path="minhaconta/alterarplano/:plan/:type"
            />
            <Route element={<Outlet />} path="treinamentos">
              <Route
                element={
                  <AdminTreinamentoList path="training" per="trn" type="list" />
                }
                path=""
              />
              <Route
                element={
                  <AdminTreinamentoList
                    path="training"
                    per="trn"
                    type="trash"
                  />
                }
                path="trash"
              />
              <Route
                element={
                  <AdminTreinamentoForm path="training" per="trn" type="add" />
                }
                path="add"
              />
              <Route
                element={
                  <AdminTreinamentoForm path="training" per="trn" type="edit" />
                }
                path=":id"
              />
              <Route
                element={
                  <AdminTreinamentoEmbed
                    path="training"
                    per="trn"
                    type="edit"
                  />
                }
                path=":id/embed"
              />
            </Route>
            <Route element={<Outlet />} path="usuarios">
              <Route
                element={
                  <AdminUsuarioList path="credential" per="usr" type="list" />
                }
                path=""
              />
              <Route
                element={
                  <AdminUsuarioList path="credential" per="usr" type="trash" />
                }
                path="trash"
              />
              <Route
                element={
                  <AdminUsuarioForm path="credential" per="usr" type="add" />
                }
                path="add"
              />
              <Route
                element={
                  <AdminUsuarioForm path="credential" per="usr" type="edit" />
                }
                path=":id"
              />
            </Route>
            <Route element={<Outlet />} path="escritorios">
              <Route
                element={
                  <AdminEscritorioList path="office" per="ect" type="list" />
                }
                path=""
              />
              <Route
                element={
                  <AdminEscritorioList path="office" per="ect" type="trash" />
                }
                path="trash"
              />
              <Route
                element={
                  <AdminEscritorioForm path="office" per="ect" type="add" />
                }
                path="add"
              />
              <Route
                element={
                  <AdminEscritorioForm path="office" per="ect" type="edit" />
                }
                path=":id"
              />
              <Route
                element={
                  <AdminEscritorioPlano path="office" per="epl" type="list" />
                }
                path=":id/plano"
              />
              <Route element={<Outlet />} path=":id/tipousuario">
                <Route
                  element={
                    <AdminEscritorioTipoUsuarioList
                      path="office"
                      per="etu"
                      type="list"
                    />
                  }
                  path=""
                />
                <Route
                  element={
                    <AdminEscritorioTipoUsuarioList
                      path="office"
                      per="etu"
                      type="trash"
                    />
                  }
                  path="trash"
                />
                <Route
                  element={
                    <AdminEscritorioTipoUsuarioForm
                      path="office"
                      per="etu"
                      type="add"
                    />
                  }
                  path="add"
                />
                <Route
                  element={
                    <AdminEscritorioTipoUsuarioForm
                      path="office"
                      per="etu"
                      type="edit"
                    />
                  }
                  path=":id"
                />
              </Route>
              <Route element={<Outlet />} path=":id/equipe">
                <Route
                  element={
                    <AdminEscritorioEquipeList
                      path="office"
                      per="eeq"
                      type="list"
                    />
                  }
                  path=""
                />
                <Route
                  element={
                    <AdminEscritorioEquipeList
                      path="office"
                      per="eeq"
                      type="trash"
                    />
                  }
                  path="trash"
                />
                <Route
                  element={
                    <AdminEscritorioEquipeForm
                      path="office"
                      per="eeq"
                      type="add"
                    />
                  }
                  path="add"
                />
                <Route
                  element={
                    <AdminEscritorioEquipeForm
                      path="office"
                      per="eeq"
                      type="edit"
                    />
                  }
                  path=":id"
                />
              </Route>
            </Route>
            <Route element={<Outlet />} path="planos">
              <Route
                element={<AdminPlanoList path="plan" per="pln" type="list" />}
                path=""
              />
              <Route
                element={<AdminPlanoList path="plan" per="pln" type="trash" />}
                path="trash"
              />
              <Route
                element={<AdminPlanoForm path="plan" per="pln" type="add" />}
                path="add"
              />
              <Route element={<Outlet />} path="config">
                <Route
                  element={
                    <AdminPlanoConfigList path="plan" per="plc" type="list" />
                  }
                  path=""
                />
                <Route
                  element={
                    <AdminPlanoConfigList path="plan" per="plc" type="trash" />
                  }
                  path="trash"
                />
                <Route
                  element={
                    <AdminPlanoConfigForm path="plan" per="plc" type="add" />
                  }
                  path="add"
                />
                <Route
                  element={
                    <AdminPlanoConfigForm path="plan" per="plc" type="edit" />
                  }
                  path=":id"
                />
              </Route>
              <Route
                element={<AdminPlanoForm path="plan" per="pln" type="edit" />}
                path=":id"
              />
              <Route
                element={<AdminPlanoConfig path="plan" per="pln" type="edit" />}
                path=":id/config"
              />
            </Route>
            <Route element={<Outlet />} path="especialidades">
              <Route
                element={
                  <AdminEspecialidadeList
                    path="specialty"
                    per="esp"
                    type="list"
                  />
                }
                path=""
              />
              <Route
                element={
                  <AdminEspecialidadeList
                    path="specialty"
                    per="esp"
                    type="trash"
                  />
                }
                path="trash"
              />
              <Route
                element={
                  <AdminEspecialidadeForm
                    path="specialty"
                    per="esp"
                    type="add"
                  />
                }
                path="add"
              />
              <Route
                element={
                  <AdminEspecialidadeForm
                    path="specialty"
                    per="esp"
                    type="edit"
                  />
                }
                path=":id"
              />
            </Route>
            <Route element={<Outlet />} path="perguntas">
              <Route
                element={<AdminPerguntaList per="prg" type="list" />}
                path=""
              />
              <Route
                element={<AdminPerguntaList per="prg" type="trash" />}
                path="trash"
              />
              <Route
                element={<AdminPerguntaForm per="prg" type="add" />}
                path="add"
              />
              <Route
                element={<AdminPerguntaForm per="prg" type="edit" />}
                path=":id"
              />
            </Route>
            <Route element={<Outlet />} path="relatorios">
              <Route
                element={<AdminRelatoriosList per="prc" type="list" />}
                path=""
              />
            </Route>
            <Route element={<Outlet />} path="wiki">
              <Route element={<AdminWiki />} path="" />
            </Route>
            <Route element={<Outlet />} path="atualizacoes">
              <Route element={<AdminAtualizacoes />} path="" />
            </Route>
            <Route element={<Outlet />} path="chat">
              <Route
                element={<AdminChatList per="cht" type="list" />}
                path=""
              />
              <Route
                element={<AdminChatForm per="cht" type="list" />}
                path=":id"
              />
            </Route>
            <Route element={<Outlet />} path="politicastermos">
              <Route
                element={<AdminPageList path="" per="pet" type="list" />}
                path=""
              />
              <Route
                element={<AdminPageList path="" per="pet" type="trash" />}
                path="trash"
              />
              <Route
                element={<AdminPageAceites type="list" />}
                path="aceites"
              />
              <Route
                element={<AdminPageForm path="" per="pet" type="add" />}
                path="add"
              />
              <Route
                element={<AdminPageForm path="" per="pet" type="edit" />}
                path=":id"
              />
              <Route element={<AdminPagePage />} path=":id/page" />
              <Route element={<AdminPageView />} path=":id/view/:ver" />
            </Route>
            <Route element={<Outlet />} path="metodospagamento">
              <Route
                element={<AdminMetodoPagamentoList per="mdp" type="list" />}
                path=""
              />
              <Route
                element={<AdminMetodoPagamentoList per="mdp" type="trash" />}
                path="trash"
              />
              <Route
                element={<AdminMetodoPagamentoForm per="mdp" type="add" />}
                path="add"
              />
              <Route
                element={<AdminMetodoPagamentoForm per="mdp" type="edit" />}
                path=":id"
              />
            </Route>
            <Route element={<Outlet />} path="tribunais">
              <Route
                element={<AdminProcessoTribunalList per="ptb" type="list" />}
                path=""
              />
              <Route
                element={<AdminProcessoTribunalList per="ptb" type="trash" />}
                path="trash"
              />
              <Route
                element={<AdminProcessoTribunalForm per="ptb" type="add" />}
                path="add"
              />
              <Route
                element={<AdminProcessoTribunalForm per="ptb" type="edit" />}
                path=":id"
              />
            </Route>
            <Route element={<Outlet />} path="instancias">
              <Route
                element={<AdminProcessoInstanciaList per="pis" type="list" />}
                path=""
              />
              <Route
                element={<AdminProcessoInstanciaList per="pis" type="trash" />}
                path="trash"
              />
              <Route
                element={<AdminProcessoInstanciaForm per="pis" type="add" />}
                path="add"
              />
              <Route
                element={<AdminProcessoInstanciaForm per="pis" type="edit" />}
                path=":id"
              />
            </Route>
            <Route element={<Outlet />} path="situacoes">
              <Route
                element={<AdminProcessoSituacaoList per="pst" type="list" />}
                path=""
              />
              <Route
                element={<AdminProcessoSituacaoList per="pst" type="trash" />}
                path="trash"
              />
              <Route
                element={<AdminProcessoSituacaoForm per="pst" type="add" />}
                path="add"
              />
              <Route
                element={<AdminProcessoSituacaoForm per="pst" type="edit" />}
                path=":id"
              />
            </Route>
            <Route element={<Outlet />} path="status">
              <Route
                element={<AdminProcessoStatusList per="pss" type="list" />}
                path=""
              />
              <Route
                element={<AdminProcessoStatusList per="pss" type="trash" />}
                path="trash"
              />
              <Route
                element={<AdminProcessoStatusForm per="pss" type="add" />}
                path="add"
              />
              <Route
                element={<AdminProcessoStatusForm per="pss" type="edit" />}
                path=":id"
              />
            </Route>
            <Route element={<Outlet />} path="tipoacao">
              <Route
                element={<AdminProcessoTipoAcaoList per="pta" type="list" />}
                path=""
              />
              <Route
                element={<AdminProcessoTipoAcaoList per="pta" type="trash" />}
                path="trash"
              />
              <Route
                element={<AdminProcessoTipoAcaoForm per="pta" type="add" />}
                path="add"
              />
              <Route
                element={<AdminProcessoTipoAcaoForm per="pta" type="edit" />}
                path=":id"
              />
            </Route>
            <Route element={<Outlet />} path="chanceganhar">
              <Route
                element={
                  <AdminProcessoChanceGanharList per="pcg" type="list" />
                }
                path=""
              />
              <Route
                element={
                  <AdminProcessoChanceGanharList per="pcg" type="trash" />
                }
                path="trash"
              />
              <Route
                element={<AdminProcessoChanceGanharForm per="pcg" type="add" />}
                path="add"
              />
              <Route
                element={
                  <AdminProcessoChanceGanharForm per="pcg" type="edit" />
                }
                path=":id"
              />
            </Route>
            <Route element={<Outlet />} path="tags">
              <Route element={<AdminTagList per="tag" type="list" />} path="" />
              <Route
                element={<AdminTagList per="tag" type="trash" />}
                path="trash"
              />
              <Route
                element={<AdminTagForm per="tag" type="add" />}
                path="add"
              />
              <Route
                element={<AdminTagForm per="tag" type="edit" />}
                path=":id"
              />
            </Route>
            <Route element={<Outlet />} path="grupopermissao">
              <Route
                element={
                  <AdminGrupoPermissaoList
                    path="permission_group"
                    per="gdp"
                    type="list"
                  />
                }
                path=""
              />
              <Route
                element={
                  <AdminGrupoPermissaoList
                    path="permission_group"
                    per="gdp"
                    type="trash"
                  />
                }
                path="trash"
              />
              <Route
                element={
                  <AdminGrupoPermissaoForm
                    path="permission_group"
                    per="gdp"
                    type="add"
                  />
                }
                path="add"
              />
              <Route
                element={
                  <AdminGrupoPermissaoForm
                    path="permission_group"
                    per="gdp"
                    type="edit"
                  />
                }
                path=":id"
              />
            </Route>
            <Route element={<Outlet />} path="permissao">
              <Route
                element={
                  <AdminPermissaoList path="permission" per="prm" type="list" />
                }
                path=""
              />
              <Route
                element={
                  <AdminPermissaoList
                    path="permission"
                    per="prm"
                    type="trash"
                  />
                }
                path="trash"
              />
              <Route
                element={
                  <AdminPermissaoForm path="permission" per="prm" type="add" />
                }
                path="add"
              />
              <Route
                element={
                  <AdminPermissaoForm path="permission" per="prm" type="edit" />
                }
                path=":id"
              />
            </Route>
            <Route element={<Outlet />} path="tipousuario">
              <Route
                element={
                  <AdminTipoDeUsuarioList
                    path="credential_type"
                    per="tdu"
                    type="list"
                  />
                }
                path=""
              />
              <Route
                element={
                  <AdminTipoDeUsuarioList
                    path="credential_type"
                    per="tdu"
                    type="trash"
                  />
                }
                path="trash"
              />
              <Route
                element={
                  <AdminTipoDeUsuarioForm
                    path="credential_type"
                    per="tdu"
                    type="add"
                  />
                }
                path="add"
              />
              <Route
                element={
                  <AdminTipoDeUsuarioForm
                    path="credential_type"
                    per="tdu"
                    type="edit"
                  />
                }
                path=":id"
              />
            </Route>
            <Route element={<Outlet />} path="tarefas">
              <Route
                element={<AdminTarefaList per="trf" type="list" />}
                path=""
              />
              <Route
                element={<AdminTarefaList per="trf" type="trash" />}
                path="trash"
              />
              <Route
                element={<AdminTaskForm per="trf" type="add" />}
                path="add"
              />
              <Route
                element={<AdminTaskForm per="trf" type="add" />}
                path="add/:id/process"
              />
              <Route
                element={<AdminTaskForm per="trf" type="add" />}
                path="add/:id/client"
              />
              <Route
                element={<AdminTaskForm per="trf" type="edit" />}
                path=":id"
              />
              <Route element={<Outlet />} path=":id/comentarios">
                <Route
                  element={<AdminTaskCommentList per="tcm" type="list" />}
                  path=""
                />
                <Route
                  element={<AdminTaskCommentList per="tcm" type="trash" />}
                  path="trash"
                />
                <Route
                  element={<AdminTaskCommentForm per="tcm" type="add" />}
                  path="add"
                />
                <Route
                  element={<AdminTaskCommentForm per="tcm" type="edit" />}
                  path=":id"
                />
              </Route>
              <Route element={<Outlet />} path=":id/documentos">
                <Route
                  element={<AdminTaskDocummentList per="tdc" type="list" />}
                  path=""
                />
                <Route
                  element={<AdminTaskDocummentList per="tdc" type="trash" />}
                  path="trash"
                />
                <Route
                  element={<AdminTaskDocumentForm per="tdc" type="add" />}
                  path="add"
                />
                <Route
                  element={<AdminTaskDocumentForm per="tdc" type="edit" />}
                  path=":id"
                />
              </Route>
            </Route>
            <Route element={<Outlet />} path="financeiro">
              <Route
                element={<AdminProcessFinancialList per="fnc" type="list" />}
                path=""
              />
              <Route
                element={<AdminProcessFinancialForm per="fnc" type="list" />}
                path=":id"
              />
            </Route>
            <Route element={<Outlet />} path="processos">
              <Route
                element={<AdminProcessList per="prc" type="list" />}
                path=""
              />
              <Route
                element={<AdminProcessList per="prc" type="trash" />}
                path="trash"
              />
              <Route
                element={<AdminProcessForm per="prc" type="add" />}
                path="add"
              />
              <Route
                element={<AdminProcessForm per="prc" type="edit" />}
                path=":id"
              />
              <Route
                element={<AdminProcessPrestacaoContas per="prc" type="edit" />}
                path=":id/prestacaodecontas"
              />
              <Route element={<Outlet />} path=":id/comentarios">
                <Route
                  element={<AdminProcessCommentList per="pcm" type="list" />}
                  path=""
                />
                <Route
                  element={<AdminProcessCommentList per="pcm" type="trash" />}
                  path="trash"
                />
                <Route
                  element={<AdminProcessCommentForm per="pcm" type="add" />}
                  path="add"
                />
                <Route
                  element={<AdminProcessCommentForm per="pcm" type="edit" />}
                  path=":id"
                />
              </Route>
              <Route element={<Outlet />} path=":id/documentos">
                <Route
                  element={<AdminProcessDocumentList per="pdc" type="list" />}
                  path=""
                />
                <Route
                  element={<AdminProcessDocumentList per="pdc" type="trash" />}
                  path="trash"
                />
                <Route
                  element={<AdminProcessDocumentForm per="pdc" type="add" />}
                  path="add"
                />
                <Route
                  element={<AdminProcessDocumentForm per="pdc" type="edit" />}
                  path=":id"
                />
              </Route>
            </Route>
            <Route element={<Outlet />} path="equipe">
              <Route
                element={<AdminEquipeList per="eqp" type="list" />}
                path=""
              />
              <Route
                element={<AdminEquipeList per="eqp" type="trash" />}
                path="trash"
              />
              <Route
                element={<AdminEquipeForm per="eqp" type="add" />}
                path="add"
              />
              <Route
                element={<AdminEquipeForm per="eqp" type="edit" />}
                path=":id"
              />
            </Route>
            <Route element={<Outlet />} path="clientes">
              <Route
                element={<AdminClienteList per="cli" type="list" />}
                path=""
              />
              <Route
                element={<AdminClienteList per="cli" type="trash" />}
                path="trash"
              />
              <Route
                element={<AdminClienteForm per="cli" type="add" />}
                path="add"
              />
              <Route
                element={<AdminClienteForm per="cli" type="edit" />}
                path=":id"
              />
              <Route element={<Outlet />} path=":id/comentarios">
                <Route
                  element={<AdminClientCommentList per="ccm" type="list" />}
                  path=""
                />
                <Route
                  element={<AdminClientCommentList per="ccm" type="trash" />}
                  path="trash"
                />
                <Route
                  element={<AdminClientCommentForm per="ccm" type="add" />}
                  path="add"
                />
                <Route
                  element={<AdminClientCommentForm per="ccm" type="edit" />}
                  path=":id"
                />
              </Route>
              <Route element={<Outlet />} path=":id/documentos">
                <Route
                  element={<AdminClientDocumentList per="cdc" type="list" />}
                  path=""
                />
                <Route
                  element={<AdminClientDocumentList per="cdc" type="trash" />}
                  path="trash"
                />
                <Route
                  element={<AdminClientDocumentForm per="cdc" type="add" />}
                  path="add"
                />
                <Route
                  element={<AdminClientDocumentForm per="cdc" type="edit" />}
                  path=":id"
                />
              </Route>
            </Route>
            <Route element={<Outlet />} path="partecontraria">
              <Route
                element={<AdminParteContrariaList per="ptc" type="list" />}
                path=""
              />
              <Route
                element={<AdminParteContrariaList per="ptc" type="trash" />}
                path="trash"
              />
              <Route
                element={<AdminParteContrariaForm per="ptc" type="add" />}
                path="add"
              />
              <Route
                element={<AdminParteContrariaForm per="ptc" type="edit" />}
                path=":id"
              />
            </Route>
            <Route element={<Outlet />} path="advogados">
              <Route
                element={<AdminAdvogadoList per="adp" type="list" />}
                path=""
              />
              <Route
                element={<AdminAdvogadoList per="adp" type="trash" />}
                path="trash"
              />
              <Route
                element={<AdminAdvogadoForm per="adp" type="add" />}
                path="add"
              />
              <Route
                element={<AdminAdvogadoForm per="adp" type="edit" />}
                path=":id"
              />
            </Route>
            <Route element={<ControllerPage404 />} path="*" />
          </Route>
        </Routes>
      </BrowserRouter>
    );
  };
}

export default AppStack;
